export const GET_COMBO_USER = "GET_COMBO_USER";
export const GET_COMBO_USER_SUCCESS = "GET_COMBO_USER_SUCCESS";
export const GET_COMBO_USER_FAILURE = "GET_COMBO_USER_FAILURE";
export const GET_CURRENT_USER = "GET_CURRENT_USER";
export const GET_CURRENT_USER_SUCCESS = "GET_CURRENT_USER_SUCCESS";
export const GET_CURRENT_USER_FAILURE = "GET_CURRENT_USER_FAILURE";
